export const getPorcentagem = (qtdRegistro: number, totalRegistros: number) => {
  return qtdRegistro > 0 && '| ' + ((qtdRegistro * 100) / totalRegistros).toFixed(1) + '%'
}
